import exportPdf from './exportPdf'
import pages from './pages'

const departments = {
  exportPdf,
  pages,
}

export default departments
